import { render, staticRenderFns } from "./table71.vue?vue&type=template&id=bacb81cc&scoped=true"
import script from "./table71.vue?vue&type=script&lang=js"
export * from "./table71.vue?vue&type=script&lang=js"
import style0 from "./table71.vue?vue&type=style&index=0&id=bacb81cc&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacb81cc",
  null
  
)

export default component.exports